var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShovel = function SvgShovel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Ebene 1",
    viewBox: "0 0 50 50"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12.26,
    height: 2.3,
    x: 12.67,
    y: 32.75,
    rx: 0.5,
    transform: "rotate(-66.51 18.797 33.905)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12.26,
    height: 2.3,
    x: 16.78,
    y: 34.62,
    rx: 0.5,
    transform: "rotate(-66.51 22.906 35.77)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m38 10.72 1.66-3.85a1 1 0 0 0-.52-1.31l-9.67-4.21a1 1 0 0 0-1.31.51l-1.67 3.85A1 1 0 0 0 27 7l1.63.7a.5.5 0 0 1 .25.66L23 21.88a.49.49 0 0 1-.66.26l-3.26-1.41a1 1 0 0 0-1.31.51L11 37a8.41 8.41 0 0 0 3.39 10.7 8.21 8.21 0 0 0 11.57-3.89l7-16a1 1 0 0 0-.52-1.32l-3.54-1.54a.49.49 0 0 1-.26-.65l5.86-13.5a.5.5 0 0 1 .66-.25l1.62.7a1 1 0 0 0 1.22-.53M23.81 42.88a5.92 5.92 0 0 1-8.32 2.8 6.09 6.09 0 0 1-2.43-7.76l6.13-14.11a.5.5 0 0 1 .66-.26l9.94 4.32a.51.51 0 0 1 .26.66zm2-19.26-.4-.17a.5.5 0 0 1-.25-.66L31 9.36a.51.51 0 0 1 .66-.26l.39.17a.51.51 0 0 1 .26.66l-5.86 13.43a.5.5 0 0 1-.65.26zm4.4-19.45L36.6 7a.5.5 0 0 1 .26.66l-.23.54a.5.5 0 0 1-.66.26l-6.39-2.82a.5.5 0 0 1-.26-.64l.23-.54a.5.5 0 0 1 .66-.29"
  })));
};
export default SvgShovel;